import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SiteHeader } from "../components/SiteHeader";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { api, setAdminToken } from "../lib/api";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      setAdminToken(data.token);
      toast.success("Signed in");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SiteHeader />
      <main className="max-w-md mx-auto px-6 py-20" data-testid="admin-login-main">
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-lg bg-slate-900 text-white mx-auto mb-4 flex items-center justify-center">
            <Lock className="w-5 h-5" />
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Admin login</h1>
          <p className="text-sm text-slate-500 mt-2">Access the admin dashboard.</p>
        </div>
        <Card className="border-slate-200 p-6">
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div className="space-y-2">
              <Label htmlFor="password" className="eyebrow">Password</Label>
              <Input
                id="password"
                data-testid="admin-password-input"
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-11"
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full h-11 bg-[#065F46] hover:bg-[#047857] text-white font-semibold"
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Signing in…
                </>
              ) : (
                "Sign in"
              )}
            </Button>
          </form>
        </Card>
      </main>
    </div>
  );
}
